const validate = values => {
    const errors = {}
    const requiredFields = [
        'firstName',
        'middleName',
        'lastName',
        'email',
        'password',
        'confirmPassword',
        'facultyNumber',
        'school',
        'speciality',
        'isGraduated',
        'degree'
    ]

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'fieldRequired'
        }
    })
    if (
        values.email &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
        errors.email = 'invalidEmail'
    }
    if (values.password && values.confirmPassword && values.password !== values.confirmPassword) {
        errors.confirmPassword = 'passwordsDoNotMatch'
    }

    if (values.hasAgreedToGdpr === undefined || (values.hasAgreedToGdpr !== undefined && !values.hasAgreedToGdpr)) {
        errors.hasAgreedToGdpr = 'gdprAgreementRequired';
    }

    return errors
}

export default validate